export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bot.table.vue?vue&type=template&id=705356be&"


//////////////////
// WEBPACK FOOTER
// ./src/components/bot/table/bot.table.vue?vue&type=template&id=705356be&
// module id = 724
// module chunks = 0 10